// removed by extract-text-webpack-plugin
module.exports = {"modalContent":"_2w3z-Mo6iCq_8LOFKtp8eS","modalButtons":"RvSMXuOA7VvxddkVe_iiU","greyButton":"_25QuAOc7pOKjxNyP2RPnR3","enabled":"_2avOymkDZ_5eMAsDXMfcSF","cancel":"_2dqpX0htV9QjWmV16EgjZz","title":"_3Xkr65hDlElkhqw4Bz5pqS","message":"_3lZfYLIjvDYhmdGRQJzhbX"};


//////////////////
// WEBPACK FOOTER
// ./components/DSDocuments/reminderEmailStatusDialog.scss
// module id = 1582
// module chunks = 0